import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getApiUrl } from '../services/api';
import './Login.css';

const publicApi = axios.create({
  baseURL: getApiUrl(),
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

export default function SetupPassword() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();
  const [ctx, setCtx] = useState(null);
  const [loadingCtx, setLoadingCtx] = useState(true);
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!token) {
      setLoadingCtx(false);
      return;
    }
    publicApi
      .get('/public/setup-password/context', { params: { token } })
      .then((res) => setCtx(res.data))
      .catch((ex) => {
        toast.error(ex.response?.data?.detail || 'Enlace inválido o expirado');
      })
      .finally(() => setLoadingCtx(false));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) return;
    if (pw.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres');
      return;
    }
    if (pw !== pw2) {
      toast.error('Las contraseñas no coinciden');
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await publicApi.post('/public/setup-password', {
        token,
        new_password: pw,
      });
      toast.success(data.message);
      navigate('/login', { replace: true, state: { postSetupUsername: data.username, tenantCode: data.tenant_code } });
    } catch (ex) {
      toast.error(ex.response?.data?.detail || 'No se pudo guardar la contraseña');
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <div className="login-container">
        <div className="login-card">
          <p>Enlace inválido: falta el token.</p>
          <Link to="/login">Ir al inicio de sesión</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img src="/logo-seven-banner.png" alt="SEVEN" className="login-logo-img" />
          </div>
          <h1 style={{ fontSize: '22px', margin: 0 }}>Definir contraseña</h1>
          <p>Completa el acceso a tu academia</p>
        </div>

        {loadingCtx && <p>Cargando…</p>}
        {!loadingCtx && ctx && (
          <div style={{ marginBottom: 16, fontSize: 14, color: '#5a6c7d' }}>
            <p style={{ margin: '0 0 8px' }}>
              <strong>Usuario:</strong> {ctx.username}
            </p>
            {ctx.tenant_code && (
              <p style={{ margin: 0 }}>
                <strong>Código organización:</strong> {ctx.tenant_code}
              </p>
            )}
          </div>
        )}

        {!loadingCtx && ctx && (
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label>Nueva contraseña</label>
              <input
                type="password"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                required
                minLength={6}
                autoComplete="new-password"
              />
            </div>
            <div className="form-group">
              <label>Confirmar contraseña</label>
              <input
                type="password"
                value={pw2}
                onChange={(e) => setPw2(e.target.value)}
                required
                minLength={6}
                autoComplete="new-password"
              />
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
              {submitting ? 'Guardando…' : 'Guardar e ir al login'}
            </button>
          </form>
        )}

        {!loadingCtx && !ctx && (
          <p>
            <Link to="/login">Volver al inicio de sesión</Link>
          </p>
        )}
      </div>
    </div>
  );
}
